import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { ModalWrapper, ModalBackground, ModalInner, ModalBox, ModalHeader as ModalHeaderSt, ModalTitle, ModalClose, ModalFooter as ModalFooterSt, ModalBody as ModalBodySt } from "./styled";

export const Modal = ({children, isOpen, toggle, size, centered, $customStyles, closeOnBackdropClick = true,} : { children: React.ReactNode; isOpen?: boolean, toggle?: () => void, size?: "sm" | "md" | "lg", centered?: boolean, $customStyles?: any, closeOnBackdropClick?: boolean;}) => {
  
  const handleToggle = () => {
    if(isOpen) document.body.style.overflow = "hidden";
    if(!isOpen) document.body.style.overflow = "";
    if (toggle) toggle();    
  };

  useEffect(() => {
    if(isOpen) document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if(!isOpen) return null;

  return (
    createPortal(
      <ModalWrapper sx={$customStyles} className="modalWrapper">
        <ModalBackground onClick={closeOnBackdropClick ? handleToggle : undefined} className="modalBackground" />
        <ModalInner $size={size} $centered={centered} className="modalInner">
          <ModalBox className="modalBox">
            {children}
          </ModalBox>
        </ModalInner>
      </ModalWrapper>
    , document.body)
  );
};


export const ModalHeader = ({children, toggle, } : { children?: React.ReactNode; toggle?: () => void }) => {

  const handleToggle = () => {
    document.body.style.overflow = "hidden";  
    if(typeof toggle === "function"){
      toggle();  
    }   
  };

  return (
    <ModalHeaderSt className="modalHeader">
      <ModalTitle>{children}</ModalTitle>
      <ModalClose type="button" onClick={handleToggle} />
    </ModalHeaderSt>
  );
}

export const ModalBody = ({children } : { children: React.ReactNode }) => {

  return (
    <ModalBodySt className="modalBody">
      {children}
    </ModalBodySt>
  );
}

export const ModalFooter = ({children, fullFooter } : { children?: React.ReactNode, fullFooter?:boolean }) => {
  return (
    <ModalFooterSt className="modalFooter" fullFooter={fullFooter}>
      {children}
    </ModalFooterSt>
  );
}